'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var index = require('./../../../external/classnames/index.js');
var useMobileBool = require('../../../utilities/hooks/useMobileBool.js');
var close_inline = require('../../../assets/svg/close.inline.svg.js');
var magnifying_glass_inline = require('../../../assets/svg/magnifying_glass.inline.svg.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SideNavSearch = function SideNavSearch(_ref) {
  var className = _ref.className,
    handleFilter = _ref.handleFilter,
    setShowMenu = _ref.setShowMenu;
  var classes = index.default('lanl-side-nav-search', className);
  var isMobile = useMobileBool.useMobileBool();
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: classes,
    "data-testid": "lanl-side-nav-search"
  }, /*#__PURE__*/React__default.default.createElement(magnifying_glass_inline.default, {
    className: "lanl-search-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 31.714 31.714"
  }), /*#__PURE__*/React__default.default.createElement("input", {
    className: "search-input",
    placeholder: "Search",
    onKeyUp: function onKeyUp(e) {
      return handleFilter(e);
    }
  }), isMobile ? /*#__PURE__*/React__default.default.createElement(close_inline.default, {
    className: "lanl-close-icon",
    onClick: function onClick(e) {
      e.stopPropagation();
      setShowMenu(false);
    }
  }) : null, /*#__PURE__*/React__default.default.createElement("div", {
    className: "lanl-searchbar-retainer"
  }));
};
SideNavSearch.defaultProps = {};
SideNavSearch.propTypes = {
  handleFilter: PropTypes__default.default.func.isRequired,
  setShowMenu: PropTypes__default.default.func.isRequired,
  className: PropTypes__default.default.string
};

exports.SideNavSearch = SideNavSearch;
exports.default = SideNavSearch;
//# sourceMappingURL=SideNavSearch.js.map
